import * as React from "react";
import { StaticImage } from "gatsby-plugin-image";

// Import layout
import Layout from "../layouts/main";

// Import components
import SEO from "../components/seo";

// Import styles
import "./styles/about.scss";

// Import assets
import image from "../assets/images/adaptix.jpg";

// Bootstrap imports
import { Button, Card, Col, Container, Jumbotron, Row } from "react-bootstrap";

const AboutPage = () => {
  return (
    <Layout>
      <SEO
        title="About | The Lisa Mae"
        description="About The Artist: Lisa Mae Osborne."
        image={`https://thelisamae.netlify.com${image}`}
      />
      <Container className="about">
        <div className="about-intro">
          <StaticImage
            className="about-image"
            src="../assets/images/lisa-osborne.jpg"
            alt="A portrait of Lisa Osborne."
          />
          <h1 className="shout">About Me</h1>
        </div>
        <div className="about-body">
          <p className="talk">
            My name is Lisa and I am an artist originally from West Virginia but
            currently located in Denver, CO. I first started drawing at a young
            age and I have always felt a sense of comfort doing it. Creativity
            has always been something that comes naturally to me and throughout
            the years my art has changed a lot, developing into what it is now.
            I like to describe my art as abstract and colorful, inspired by
            flowers, organic shapes, nature, and depicting self-love.
          </p>
          <p className="talk">
            I fell in love with flowers while strolling through gardens with my
            Grandma. She always appreciated their beauty, strength, and stoic
            nature. My Grandma passed away a while ago, but since her passing I
            started to notice the deep connection I have with flowers and I feel
            lucky to have shared this with my favorite person.{" "}
          </p>
          <p className="talk">
            I hope my art brings you happiness, peace, and love. I truly believe
            that with art each line means something different to someone. The
            artist, the friend, the stranger, or yourself.
          </p>
          <p className="talk">Thank you so much for exploring my artwork.</p>
        </div>
      </Container>
    </Layout>
  );
};

export default AboutPage;
